import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const IMAGE_MENU: PermissionTableRowType = {
  name: '원격 이미지',
  key: 'IMAGE_MANAGE',
  subRows: [
    {
      name: '스플래시 이미지',
      key: PERMISSION_SUBJECTS.REMOTE_SPLASH_IMAGE,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
      ],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.REMOTE_SPLASH_IMAGE,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '스플래시 이미지 등록',
          key: PERMISSION_SUBJECTS.REMOTE_SPLASH_IMAGE,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '스플래시 이미지 편집',
          key: PERMISSION_SUBJECTS.REMOTE_SPLASH_IMAGE,
          permissions: [PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
    {
      name: '래퍼럴 이미지',
      key: PERMISSION_SUBJECTS.REMOTE_REFERRAL_IMAGE,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
      ],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.REMOTE_REFERRAL_IMAGE,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '래퍼럴 이미지 등록',
          key: PERMISSION_SUBJECTS.REMOTE_REFERRAL_IMAGE,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '래퍼럴 이미지 편집',
          key: PERMISSION_SUBJECTS.REMOTE_REFERRAL_IMAGE,
          permissions: [PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
  ],
};
